import { z } from 'zod'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { airportRequired, isEmpty, optional, required } from './schemaHelpers'

const language = cap.language.state || 'IT'
const t = translations[language]

const MSG = t.gfCampoObbligatorio

/**
 * Su Goelett gli IATA non sono un vincolo della Search: il luogo si risolve alla
 * ricerca sui location point. Il form può mostrare la città senza codice.
 *
 * @param {{ enableArrivoEntro?: boolean, isGoelett?: boolean }} options
 */
export const buildPlaneServiceSchema = ({ enableArrivoEntro = true, isGoelett = false } = {}) =>
  z
    .object({
      typeTrip: required(),
      departureDate: required(),
      airportDeparture: isGoelett ? optional() : airportRequired(),
      airportArrival: isGoelett ? optional() : airportRequired(),
      arrivalDate: optional(),
      fromHourDeparture: optional(),
      toHourDeparture: enableArrivoEntro ? optional() : z.any().optional(),
      fromHourReturn: optional(),
      toHourReturn: enableArrivoEntro ? optional() : z.any().optional(),
      companyName: optional(),
      classType: optional(),
      seatPreference: optional(),
      luggageType: optional(),
      luggageNumber: optional(),
      luggageWeight: optional(),
      typeBoarding: optional(),
      companyCode: optional(),
      noteAggiuntive: optional()
    })
    .superRefine((data, ctx) => {
      if (data.typeTrip === 'RT' && isEmpty(data.arrivalDate)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['arrivalDate'], message: MSG })
      }
    })
